import { TitleH3 } from "@/components/shared/public";
import { PropsWithChildren } from "react";

const Section = ({
  title,
  children,
}: PropsWithChildren<{ title?: string }>) => {
  return (
    <div className="text-ring flex flex-col gap-5">
      {title && <TitleH3 title={title} />}
      {children}
    </div>
  );
};

export default Section;
